module.exports = __webpack_public_path__ + "media/Images/icon-dollar-currency-o-72b7f215db1ca8545adf3ec8983fef40.svg";